"use client";

import { createContext, type ReactNode } from "react";
import type { CreatorLocale } from "./locales";
import type en from "./messages/en";

export type CreatorMessages = typeof en;

/**
 * The creator surfaces' language and catalogue, for the components that also
 * render on internal (Framework) pages.
 *
 * next-intl's hooks throw without its provider, and internal pages have none
 * on purpose: they are English-only and carry no i18n wiring. So the shared
 * components read from this context instead, through
 * `useCreatorTranslations`, and get English when it is empty. Only the `/one`
 * and `/join` layouts fill it, via `CreatorIntlProvider`.
 */
export const CreatorMessagesContext = createContext<{
  locale: CreatorLocale;
  messages: CreatorMessages;
} | null>(null);

export function CreatorMessagesProvider({
  locale,
  messages,
  children,
}: {
  locale: CreatorLocale;
  messages: CreatorMessages;
  children: ReactNode;
}) {
  return (
    <CreatorMessagesContext value={{ locale, messages }}>
      {children}
    </CreatorMessagesContext>
  );
}
